<template>
  <app-dialer-common-popup
    :key="actionsType"
    :title="title"
    class="app-dialer-actions-popup"
    @close="$emit('close')"
  >
    <app-dialer-transfer-content
      :avatar="avatar"
      :agents="agentOptions"
      :rule-groups="ruleGroups"
      :tabs="content"
      :agent-actions-type="actionsType"
      :context="context"
      :statuses="statuses"
      :default-search-options="defaultSearchOptions"
      :can-change-search-options="canChangeSearchOptions"
      :show-agents-tab="showAgentsTab"
      :are-agent-actions-disabled="isPerformingAction"
      :can-invite-third-party="canInviteThirdParty"
      tabs-type="inline"
      actions-type="inline"
      size="desktop"
      @invite-agent="onInviteAgent"
      @invite-3rd-party="onInvite3rdParty"
    />
  </app-dialer-common-popup>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';

import AppDialerCommonPopup from '../../components/common/AppDialerCommonPopup.vue';
import AppDialerTransferContent from '../../components/controls/AppDialerTransferContent.vue';
import {
  useCommonProps,
  useDialerStore,
  useAgentActionsProps,
  useAgentsActions,
} from '../../composables';

export default defineComponent({
  name: 'AppDialerActionsPopupContainer',
  components: {
    AppDialerCommonPopup,
    AppDialerTransferContent,
  },
  props: {
    /** Also used as a key to trigger re-render between value switches */
    actionsType: {
      type: String as PropType<'invite' | 'transfer'>,
      default: 'invite',
    },
  },
  emits: ['close'],
  setup(props) {
    const { avatar, ruleGroups, statuses } = useCommonProps();
    const {
      tabs,
      isPerformingAction,
      agentOptions,
    } = useDialerStore();
    const {
      title,
      showAgentsTab,
      content,
      context,
      canInviteThirdParty,
      defaultSearchOptions,
      canChangeSearchOptions,
    } = useAgentActionsProps(props);
    const { onInviteAgent, onInvite3rdParty } = useAgentsActions(props);

    return {
      avatar,
      agentOptions,
      ruleGroups,
      statuses,
      tabs,
      title,
      showAgentsTab,
      content,
      context,
      canInviteThirdParty,
      defaultSearchOptions,
      canChangeSearchOptions,
      isPerformingAction,
      onInviteAgent,
      onInvite3rdParty,
    };
  },
});
</script>

<style lang="scss" scoped>
.app-dialer-actions-popup {
  height: 31.25rem;
  width: 37.5rem;

  & > ::v-deep .content {
    display: flex;
    flex-direction: column;
  }

  [data-component='app-dialer-transfer-content'] {
    flex: 1 1 100%;
  }
}
</style>
